import { ORDER_BUILDER_ROUTES } from '../../constants/order-builder-routes';
import { StepRoute } from '../../models/step-route.model';

/**
 * Bulk admixture order creation
 */
export const adtWay: StepRoute[] = [
    {
      name: 'views.builder.product_line',
      route: ORDER_BUILDER_ROUTES.BusinessLine,
    },
    {
      name: 'views.builder.location',
      route: ORDER_BUILDER_ROUTES.Location,
    },
    {
      name: 'views.builder.specifications',
      route: ORDER_BUILDER_ROUTES.AdtSpecification,
    },
    {
      name: 'views.builder.summary',
      route: ORDER_BUILDER_ROUTES.AdtSummary,
    },
  ];
